import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";
import ErrorBoundary from "../routes/System/ErrorBoundary";
import Error from "../routes/System/Error";

const App = ({ match }) => {
  return (
    <div className="gx-main-content-wrapper">
      <ErrorBoundary>
        <Switch>
          <Route path={`${match.url}admin`} component={asyncComponent(() => import('./Admin'))} />
          <Route path={`${match.url}job/lodge`} component={asyncComponent(() => import('./Business/Job/LodgeJob'))} />
          <Route path={`${match.url}jobs`} component={asyncComponent(() => import('./Business/Job/JobPaging'))} />
          <Route path={`${match.url}my-jobs`} component={asyncComponent(() => import('./Business/Job/MyJobPaging'))} />
          <Route path={`${match.url}job/detail`} component={asyncComponent(() => import('./Business/Job/JobDetail'))} />
          <Route path={`${match.url}job/new`} component={asyncComponent(() => import('./Business/Job/JobNew'))} />
          <Route path={`${match.url}my-profile`} component={asyncComponent(() => import('./MyProfile'))} />
          <Route path={`${match.url}stats`} component={asyncComponent(() => import('./Business/Stats'))} />
          <Route path={`${match.url}report`} component={asyncComponent(() => import('./Business/Report'))} />
          <Route path={'/error'} component={Error} />
        </Switch>
      </ErrorBoundary>
    </div>
  )

};

export default App;
